import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const CTABanner = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 px-6 bg-gradient-to-r from-[#003366] to-[#004488]" data-testid="cta-banner">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Solve Your Staffing Challenges?
        </h2>
        <p className="text-lg text-blue-200 mb-8 max-w-2xl mx-auto">
          Whether you need reliable workers for your next project or you&apos;re looking for your next opportunity, WorkNation Labour Ltd is here to help.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => navigate('/employers')}
            className="bg-white text-[#003366] hover:bg-gray-100 px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
            data-testid="cta-employer-btn"
          >
            Get Workers in 24-48 Hours
            <ArrowRight className="ml-2" size={20} />
          </Button>
          <Button
            onClick={() => navigate('/job-seekers')}
            className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#003366] px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
            data-testid="cta-jobseeker-btn"
          >
            Start Earning This Week
            <ArrowRight className="ml-2" size={20} />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
